import React from 'react';
import { motion } from 'framer-motion';
import TypeWriter from './TypeWriter.tsx';

interface ResultProps {
  type: string;
  description: string;
  onRestart: () => void;
}

const Result: React.FC<ResultProps> = ({ type, description, onRestart }) => {
  return (
    <motion.div
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      className="fixed inset-0 w-full h-full flex items-start justify-center bg-gray-950 overflow-y-auto"
    >
      <motion.div 
        className="fixed inset-0 w-full h-full bg-cover bg-center bg-no-repeat opacity-90 bg-fixed"
        style={{
          backgroundImage: 'url(/images/result.png)'
        }}
      />
      
      <motion.div
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ delay: 0.5 }}
        className="relative z-10 w-full max-w-3xl mx-auto px-8 py-12 space-y-12 min-h-screen"
      >
        <motion.div
          initial={{ scale: 0.9, opacity: 0 }}
          animate={{ scale: 1, opacity: 1 }}
          transition={{ delay: 1 }}
          className="text-center sticky top-8"
        >
          <h2 className="text-3xl font-bold text-white mb-6">你的旅者类型</h2>
          <div className="text-7xl font-bold text-green-400 mb-8 tracking-[0.2em]">{type}</div>
        </motion.div>

        <motion.div
          initial={{ y: 20, opacity: 0 }}
          animate={{ y: 0, opacity: 1 }}
          transition={{ delay: 1.5 }}
          className="bg-black bg-opacity-60 backdrop-blur-sm rounded-xl p-8 text-white shadow-xl"
        >
          <h3 className="text-2xl font-semibold text-green-400 mb-6">旅者画像</h3>
          <div className="text-lg leading-relaxed space-y-4">
            <TypeWriter text={description} speed={15} />
          </div>
        </motion.div>

        <motion.div
          initial={{ y: 20, opacity: 0 }}
          animate={{ y: 0, opacity: 1 }}
          transition={{ delay: 2 }}
          className="flex flex-col items-center space-y-4 mt-12 sticky bottom-8 pb-8"
        >
          <motion.button
            whileHover={{ scale: 1.05 }}
            whileTap={{ scale: 0.95 }}
            onClick={onRestart}
            className="px-10 py-4 bg-green-600 bg-opacity-90 text-white text-xl font-semibold rounded-lg shadow-lg hover:bg-opacity-100 transition-all"
          >
            重新探索
          </motion.button>
          
          <motion.button
            whileHover={{ scale: 1.05 }}
            whileTap={{ scale: 0.95 }}
            onClick={() => {
              const text = `我在森木星球探索中发现自己是 ${type} 类型的旅者！\n${description}`;
              if (navigator.share) {
                navigator.share({
                  title: '森木 - 沉浸式 MBTI 测试',
                  text: text,
                  url: window.location.href
                });
              } else {
                navigator.clipboard.writeText(text).then(() => {
                  alert('结果已复制到剪贴板！');
                });
              }
            }}
            className="px-10 py-4 bg-white bg-opacity-20 backdrop-blur-sm text-white text-xl font-semibold rounded-lg shadow-lg hover:bg-opacity-30 transition-all"
          >
            分享旅程
          </motion.button>
        </motion.div>
      </motion.div>
    </motion.div>
  );
};

export default Result; 